import { env } from "../env";
import { api, clearAdminUnlock } from "./client";
import type { AdminUnlockResponse, SessionUser } from "@titancloud/shared";

export async function getMe(): Promise<SessionUser> {
  return api.get<SessionUser>("/auth/me");
}

export async function setupAdminPassword(password: string): Promise<AdminUnlockResponse> {
  return api.post("/auth/admin-password/setup", { password });
}

export async function verifyAdminPassword(password: string): Promise<AdminUnlockResponse> {
  return api.post("/auth/admin-password/verify", { password });
}

export async function logout(): Promise<void> {
  clearAdminUnlock();
  await api.post("/auth/logout");
}

export function getGoogleLoginUrl(): string {
  return `${env.VITE_API_URL}/api/auth/google`;
}
